import DesktopHeader from 'components/views/Landing/header-desktop.view'
import { Fragment } from 'react'
import { Outlet } from 'react-router-dom'

const LandingLayout = () => {
  return (
    <Fragment>
      <DesktopHeader />
      <Outlet />
    </Fragment>
  )
}

export default LandingLayout
